import api from '@Api/Api'
import { BaseApi } from '@Features/Base/BaseApi/BaseApi'

const SettingsApi = BaseApi.injectEndpoints({
	endpoints: builder => ({
		logoutDevice: builder.mutation<ApiResponse<Device>, DeviceId>({
			query: payload => ({
				url: 'devices/logout/single',
				method: 'POST',
				// Addressed by the server-minted uuid, not the old client-supplied
				// device_id — a value the browser chose was never safe to look a row
				// up by.
				body: {
					uuid: payload.uuid,
				},
			}),
		}),
	}),
})

export const { useLogoutDeviceMutation } = SettingsApi

export default class TrustedDevicesApi {
	public static getAllDevices() {
		return api.get<ApiResponse<Device[]>>('/devices/fetch')
	}
	public static logoutAllDevices() {
		// POST, not GET. It revokes every device and deletes their tokens, so it
		// must not be reachable by a link, a prefetch or a crawler.
		return api.post<ApiResponse<Device[]>>('/devices/logout/all')
	}
}
